import styled from 'styled-components'
import { Heading, OrderedBreadcrumbs } from '@sketch/components'

export const BreadcrumbsWrapper = styled.div`
  margin-top: 41px; /* stylelint-disable-line scales/space */
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  /* Fix the payment step title margin that shows an extra spacing that's unwanted */
  & + ${Heading.H1} {
    margin-top: 0px;
  }
`

export const StyledOrderedBreadcrumbs = styled(OrderedBreadcrumbs)`
  z-index: initial;
`

export const H1 = styled(Heading.H1)`
  text-align: center;
  margin: 32px 0 40px;
  font-size: ${({ theme }) => theme.fontSizes.I};
  line-height: 1.2;
`

export const H2 = styled(Heading.H2)`
  font-weight: 700;
  line-height: 1.6;
  margin-top: 0;
  margin-bottom: 4px;
`

export const Text = styled.p`
  font-size: ${({ theme }) => theme.fontSizes.E};
  color: ${({ theme }) => theme.colors.foreground.secondary.C};
  margin: 0;
`
